module.exports = __webpack_public_path__ + "static/media/02_MINS-2.0-C-14 1.2dc9e507.svg";